import React from "react";
import { Container, Row, Col } from "reactstrap";
import { aboutpageData } from "../Data/ComponentsData/componentsdata";

const About = () => {
  return (
    <section id='about' className='pb-0 about'>
      <div className='about-chat'>
        <Container>
          <Row>
            <Col md={12} className='text-center'>
              <div className='section-title'>
                <h2>About Chat Loop</h2>
                <img src='assets/images/title-line.png' alt='title-line' className='img-fluid' />
              </div>
            </Col>
            <Col md={12} className='about-box'>
              <Row>
                {aboutpageData.map((item, index) => (
                  <Col lg={3} sm={6} key={index} className='about-border'>
                    <div className='chat-box'>
                      <img src={item.src} alt={item.alt} />
                      <h3 className='sub-title'>{item.title}</h3>
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
            <Col md={12}>
              <div className='chat-slide'>
                <h3>Connect with People all over the world, with your small device</h3>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Container fluid className='text-center'>
        <img src='assets/images/banner.png' alt='banner.png' className='img-fluid full-banner' />
      </Container>
    </section>
  );
};

export default About;
